import React from "react";
import T from "prop-types";
import {
  CITY,
  COMPANY_NAME,
  COUNTRY,
  LINE2,
  POSTAL_CODE,
  STATE,
  CARE_OF
} from "APP_ROOT/constants";
import { CompanyName } from "MODULES/shared/components";
import { dropShip } from "MODULES/SalesOrders/helpers";
import { getCarrierLabel, getShippingMethod } from "MODULES/shared/helpers";

const ShipTo = ({ parentRecord }) => {
  if (!parentRecord) {
    return (
      <div
        className="panel panel-default panel-note animate-row"
        style={{ height: "330px" }}
      />
    );
  }
  const shippingAddress = parentRecord.ship_to_address;
  const shipToShippingMethod = parentRecord.ship_to_shipping_method;
  const shipToShippingType = parentRecord.ship_to_type;

  if (!shippingAddress) return null;
  return (
    <div className="well">
      <h6 className="h4">Shipment Summary</h6>

      <table className="table table-condensed">
        <tbody>
          {shippingAddress[COMPANY_NAME] &&
            dropShip(parentRecord.ship_to_type) && [
              <tr>
                <th className="text-right">Company:</th>
                <td>{shippingAddress[COMPANY_NAME]}</td>
              </tr>
            ]}
          {shippingAddress[CARE_OF] &&
            dropShip(shipToShippingType) && (
              <tr>
                <th className="text-right">c/o</th>
                <td>{shippingAddress.care_of}</td>
              </tr>
            )}
          <tr>
            <th className="text-right">Cust. Ph</th>
            <td>
              {(parentRecord.company && parentRecord.company.phone) ||
                (parentRecord.ship_to_company &&
                  parentRecord.ship_to_company.phone)}
            </td>
          </tr>
          {parentRecord.ship_to_company && (
            <tr>
              <th className="text-right">Company</th>
              <td>
                <CompanyName
                  company={parentRecord.ship_to_company}
                  truncateAt={12}
                />
              </td>
            </tr>
          )}
          <tr>
            <th className="text-right">Address</th>
            <td>
              {shippingAddress.line1}
              {shippingAddress[LINE2] && [<br />, shippingAddress[LINE2]]}
            </td>
          </tr>
          <tr>
            <th className="text-right">City</th>
            <td>{shippingAddress[CITY]}</td>
          </tr>
          <tr>
            <th className="text-right">St/Prov</th>
            <td>{shippingAddress[STATE]}</td>
          </tr>
          <tr>
            <th className="text-right">ZIP</th>
            <td>{shippingAddress[POSTAL_CODE]}</td>
          </tr>
          <tr>
            <th className="text-right">Country</th>
            <td>{shippingAddress[COUNTRY]}</td>
          </tr>
          {shipToShippingMethod &&
            parentRecord.code &&
            parentRecord.code.includes("SO") && [
              <tr>
                <th className="text-right">Ship To</th>
                <td>{getCarrierLabel(shipToShippingMethod.carrier)}</td>
              </tr>,
              <tr>
                <th className="text-right">Ship Met</th>
                <td>
                  {getShippingMethod(
                    shipToShippingMethod.carrier,
                    shipToShippingMethod.shipping_method
                  )}
                </td>
              </tr>
            ]}
        </tbody>
      </table>
    </div>
  );
};

ShipTo.propTypes = {
  parentRecord: T.shape({}),
  shippingRecord: T.shape({})
};

export default ShipTo;



// WEBPACK FOOTER //
// ./app/modules/Shipping/components/Dashboard/Create/ShipTo.jsx